export const styles = {
  address: {
      color: "white",
      fontSize: 11,
        margin: [0, 35, 40, 0]
  },
  alignRight: {
        alignment: "right",
  },
  attentionColumn: {
    margin: [0, 0, 50, 0],
  },
  bidNumberColumn: {
      margin: [0, 0, 50, 0],
  },
  bidTotalColumn: {
      alignment: "right",
      margin: [0, 0, 0, 0],
  },
  contactInfo: {
      color: "white",
      fontSize: 11,
      margin: [0, 35, 30, 0]
  },
  header: {
      margin: [-40,-40,-40,0],
      fillColor: "#8493a3",
  },
  headerTitle: {
      color: 'white',
      alignment: 'center',
      fontSize: 40,
      bold: true,
      margin: [40, 30, 0, 0]
  },
  infoHeaderText: {
    color: "#8493a3",
    margin: [0, 0, 0, 5]
  },
  infoSubheaderText: {
      color: "#8493a3",
      margin: [0, 5, 0, 5]
  },
  bidInfo: {
      margin: [0, 30, 0, 0]
  },
  label: {
      color: "#8493a3",
  },
  lineItems: {
      margin: [10, 10, 10, 10]
  },
  sectionFooter: {
      margin: [0, 0, 0, 20],
  },
  sectionHeader: {
      margin: [0, 0, 0, 10],
  },
  tableHeaderNumber: {
      alignment: "right",
      color: "#8493a3",
      margin: [0, 10, 0, 10]
  },
  tableHeaderText: {
      color: "#8493a3",
      margin: [0, 10, 0, 10]
  },
  task: {
    margin: [0, 10, 0, 10]  ,
  },
};



// WEBPACK FOOTER //
// ./src/store/generators/PDF/bid/styles.js